import clsx from 'clsx';

import * as api from '@gitbook/api-client';
import { InlineInputEdit, toast } from '@gitbook/spine-react';
import { getChangeRequestSubject } from '@gitbook/util-format';

import { apiClient } from '../../state';

/**
 * Editable subject for the change request
 */
export function ChangeRequestSubject(props: {
    space: api.Space;
    changeRequest: api.ChangeRequest;
    size?: 'small' | 'medium' | 'large';
    editable?: boolean;
}) {
    const { space, changeRequest, size = 'medium', editable = false } = props;

    const subject = getChangeRequestSubject(changeRequest);

    return (
        <InlineInputEdit
            data-testid="changeRequest.subject"
            kind="highlighted"
            className={clsx(
                {
                    medium: 'px-2 text-ui-heading-medium',
                    small: 'px-1 text-ui-action',
                    large: 'px-2 text-ui-heading-large',
                }[size]
            )}
            readOnly={!editable || !space.permissions.edit}
            value={subject}
            placeholder="Untitled"
            maxLength={api.CHANGE_REQUEST_SUBJECT_MAX_LENGTH}
            onSave={async (value, { reset }) => {
                if (value === changeRequest.subject) {
                    reset();
                    return;
                }

                await toast.catch(async () => {
                    await apiClient.changeRequests.updateChangeRequestById(
                        space.id,
                        changeRequest.id,
                        {
                            subject: value,
                        }
                    );
                }, 'Error while updating subject');
            }}
        />
    );
}
